export const BASE_URL = 'https://thecfagroup.org/v1/api/'